var _svg;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// This file is automatically generated from generateIllustrations.js
import * as React from 'react';
import IllustrationContainer from '../IllustrationContainer.js';

function DebitCardIllustration(props) {
  return /*#__PURE__*/React.createElement(IllustrationContainer, _extends({}, props, {
    children: _svg || (_svg = /*#__PURE__*/React.createElement("svg", {
      width: "100%",
      height: "100%",
      viewBox: "0 0 128 128",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M124 42.962H4a2 2 0 00-2 2V56.09a2 2 0 002 2h120a2 2 0 002-2V44.962a2 2 0 00-2-2z",
      fill: "#009CEB"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M80.947 28H4a2 2 0 00-2 2v68.168a2 2 0 002 2h120a2 2 0 002-2V30a2 2 0 00-2-2H80.947z",
      stroke: "currentColor",
      strokeWidth: 3,
      strokeMiterlimit: 10,
      strokeLinejoin: "round"
    })))
  }));
}

export default DebitCardIllustration;